<template>
    <div>
        <h1>Overview of general Analytics</h1>
        
        <div class="flex flex-wrap m-4 text-center">
            <div class=" sm:w-1/4 md:w-1/3 w-1/2">
            <main class="border-2 border-gray-700 rounded-lg py-4 m-2">
                <h2
                class="title-font font-medium sm:text-4xl text-3xl text-gray-900"
                >
                {{ overview.total_programs }}
                </h2>
                <p class="leading-relaxed">Total Programs</p>
            </main>
            </div>
            <div class=" sm:w-1/4 md:w-1/3 w-1/2">
            <main class="border-2 border-gray-700 rounded-lg py-4 m-2">
                <h2
                class="title-font font-medium sm:text-4xl text-3xl text-gray-900"
                >
                {{ overview.learner_learning }}
                </h2>
                <p class="leading-relaxed">Total Learners Learning</p>
            </main>
            </div>
            <div class=" sm:w-1/4 md:w-1/3 w-1/2">
            <main class="border-2 border-gray-700 rounded-lg py-4 m-2">
                <h2
                class="title-font font-medium sm:text-4xl text-3xl text-gray-900"
                >
                {{ overview.average }}%
                </h2>
                <p class="leading-relaxed">Participation ratio</p>
            </main>
            </div>
        
        </div>
        
        <h1>Average Completion rate</h1>
        <div class="mt-3
        ">
            <GChart
            type="ColumnChart"
            :data="chartData"
            :options="chartOptions"
            style="height: 400px;"
            />
            
        </div>

        <h1 class="mt-3">Top 5 lowest learning rate</h1>
        <div class="mt-3
        ">
            <GChart
            type="PieChart"
            :data="pieData"
            :options="pieOptions"
            :resizeDebounce="500"
            style="height: 400px;"
            />
            
        </div>
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import { mapActions,mapMutations } from "vuex";
    export default {
        name:'tenant-users-analytics',
        components: {
            GChart,
            LDashboardCard: () => import("@/components/tenant/dashboard-card"),
        },
        data () {
            return {
                // Array will be automatically processed with visualization.arrayToDataTable function
                chartData: [
                    ['Course', 'Started', 'Finished'],
                ],
                chartOptions: {
                    chart: {
                        title: 'Average Completion rate',
                        subtitle: 'Sales, Expenses, and Profit: 2014-2017',
                    },
                    colors: ['#17B7FF','#4BB543'],
                
                },
                pieData: [
                    ['Course', 'Low learning rate'],
                ],
                pieOptions: {
                    chart: {
                        title: 'Average Completion rate',
                        subtitle: 'Sales, Expenses, and Profit: 2014-2017',
                    },
                
                },
                overview:''
                
            }
        },
        methods:{
            ...mapActions(["getTenantAnalytics"]),
            ...mapMutations(["updateLoader"])
        },
        async mounted() {
            this.updateLoader(true)
            const res = await this.getTenantAnalytics();

            this.overview = res.data.part_1;
            const data = res.data.part_2;
            
            data.forEach(singleData => {
                this.chartData.push(Object.values(singleData));
            });

            // console.log(res.data.part_3)
            const pieData = res.data.part_3;
            pieData.forEach(singleData => {
                this.pieData.push(Object.values(singleData));
            });

            this.updateLoader(false)
            // this.pieData.push(pieData);

            
        },
    }
</script>